
import Styled from "styled-components";

const DrawerWrapper = Styled.div`
.drawer-padding{
    padding:30px;
    height:100vh;
    overflow:auto;
    .product-details{
    background-color: ${({ theme }) => theme["mercury-color"]}20; 
    padding:24px;
    border:1px solid ${({ theme }) => theme["outline-color"]};
    border-radius:4px;
    .info{
                 div{
                     display:flex;
                     flex-direction:column;
                    span:nth-child(1){
                    font-size: ${({ theme }) => theme["base-font-size-small"]};
                    padding-bottom:0px;
                    color:${({ theme }) => theme["regent_gray"]} ;
                    text-transform: capitalize;
                }
                    span:nth-child(2){
                        font-size: ${({ theme }) => theme["medium-font-size"]};
                        color:${({ theme }) => theme["secondary-color"]} ;
                    }
                 }
                 .ellipse {
                    white-space: nowrap; 
                    overflow: hidden;
                    text-overflow: ellipsis; 
                 }
    }
    .units {
        div {
            span:first-child{
                font-size: ${({ theme }) => theme["medium-font-size"]};
                color:${({ theme }) => theme["secondary-color"]} ;
            }
            span:nth-child(2) {
                font-size: ${({ theme }) => theme["font-size-small"]};
                color:${({ theme }) => theme["regent_gray"]} ;
            }
        }
    }
    .note-text {
        width: 300px;
    }
    .product-status {
        width: 175px;
    }
}

}
.add-weight{
            margin-top:18px;
            grid-column-gap:18px;
            label{
                margin-bottom:3px;
                font-size:${({ theme }) => theme["base-font-size-small"]};
                color:${({ theme }) => theme["regent_gray"]}
            }
            .form-control{
                border-right:0;
                height:32px;
                color:${({ theme }) => theme["disabled-color"]};
                font-size:${({ theme }) => theme["medium-font-size"]};
                &::placeholder{
                color:${({ theme }) => theme["disabled-color"]};
                font-size:${({ theme }) => theme["medium-font-size"]};   
                }
            }
            .input-group-text{
                background:transparent;
                color:${({ theme }) => theme["disabled-color"]};
                font-size:${({ theme }) => theme["medium-font-size"]};
                border-left:0;
                height:32px;
            }
        }

.create-shipment{
    h4{
        font-size:${({ theme }) => theme["base-font-size"]}; 
        margin-bottom:12px;
    }
    .shipment-plan{
        min-width:205px;
        padding:12px;
        border: 1px solid ${({ theme }) => theme["outline-color"]};
        border-radius: ${({ theme }) => theme["border-radius-base"]};;
        cursor:pointer;
        span{
            color:${({ theme }) => theme["secondary-color"]}; 
            font-size:${({ theme }) => theme["medium-font-size"]};
        }
        &.active{
            background-color:${({ theme }) => theme["primary-color"]}; 
            span{
                color:${({ theme }) => theme["white-color"]};  
            }
        }
    }
}
.sub-heading{
    margin-top:24px;
    h4{
        font-size:${({ theme }) => theme["base-font-size"]}; 
        margin-bottom:12px;
    } 
    .input-details {
        width: 100%;
        height: calc(100vh - 400px);
        border: 1px solid ${({ theme }) => theme["outline-color"]};
        border-radius: 4px;
        padding: 16px;
        position: relative;

        .stepper-btn {
            position: absolute;
            bottom: 8px;
            right: 16px;
        }
    }
}
.box-category{
    h4{
        font-size:${({ theme }) => theme["base-font-size"]}; 
        margin-bottom:12px;
    }  
}
.info-status {
    background: rgba(0, 163, 255, 0.05);
    border: 1px solid ${({ theme }) => theme["information-color"]};
    border-radius: 4px;
    padding: 8px 12px;
}
.badge-success {
    background-color:${({ theme }) => theme["success-color"]}10;
    border:1px solid ${({ theme }) => theme["success-color"]};
    font-size:${({ theme }) => theme["base-font-size-small"]};
    border-radius:50px;
    padding:0 8px;
    color:${({ theme }) => theme["success-color"]};
}
.badge-danger {
    background-color:${({ theme }) => theme["danger-color"]}10;
    border:1px solid ${({ theme }) => theme["danger-color"]};
    font-size:${({ theme }) => theme["base-font-size-small"]};
    border-radius:50px;
    padding:0 8px;
    color:${({ theme }) => theme["danger-color"]};
}
.box-height {
    height: 180px;
    overflow: auto;
}
.add-box {
    border: 1px solid ${({ theme }) => theme["primary-color"]};
    border-radius: 4px;
    width: 32px;
    height: 32px;
    color: ${({ theme }) => theme["primary-color"]};
    cursor: pointer;
}
`;

export { DrawerWrapper };
